import styled from "@emotion/styled";
import { Box } from "@mui/material";
import badgeIcon from "assets/img/discount-badge.svg";
import { get } from "lodash";
import { defaultDesingItems } from "utils/constants";

const { colors: c } = defaultDesingItems;

const StyledRates = styled(Box)`
  box-shadow: 0px 2px 4px rgba(108, 114, 146, 0.1);
  border-radius: 8px 8px 16px 16px;
  color: ${(props) => get(props, "design.colors.text", c.text)};

  .rates-container {
    width: 100%;
    display: flex;

    .arrow {
      width: 30px;
      display: none;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      background: #f5f4f9;

      img {
        width: 7px;
      }

      &.disabled {
        display: none;
      }
    }
  }

  .swiper {
    height: 80px;
    margin: 0px auto;
    display: flex;
    flex: 1;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    position: relative;
    background: white;

    &:hover {
      .swiper-button-next,
      .swiper-button-prev {
        display: grid;
      }
    }
  }

  .swiper-slide {
    &.active .rate-slide {
      background: ${(props) => get(props, "design.colors.primary", c.primary) + "30"} !important;
      border: 1px solid ${(props) => get(props, "design.colors.primary", c.primary)};
      position: relative;

      &::after {
        content: "";
        width: 1px;
        height: 100%;
        position: absolute;
        left: -1px;
        top: 0;
        z-index: 2;
        background: #f5f4f9;
      }

      &::before {
        content: "";
        width: 1px;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        background: ${(props) => get(props, "design.colors.primary", c.primary)};
      }
    }

    .rate-slide:hover {
      background: ${(props) => get(props, "design.colors.primary", c.primary) + "30"} !important;
    }

    .rate-slide {
      background: #f5f4f9;
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 100%;
      cursor: pointer;
      border: 1px solid #e3e3e6;
      border-left: 0 !important;

      &.discount {
        .rate-name {
          font-size: 14px;
        }
      }
    }

    .rate-discount {
      min-width: 40px;
      display: inline-block;
      margin-left: 10px;
      background-image: url(${badgeIcon});
      background-position: 0;
      background-size: contain;
      padding-left: 10px;
      background-repeat: no-repeat;

      span {
        display: flex;
        font-size: 12px;
        align-items: center;
        background: #48bbb8;
        height: 20px;
        color: white;
        padding-right: 5px;
        border-radius: 0 3px 3px 0;
      }
    }

    .rate-name,
    .rate-price {
      display: inline-block;
      max-width: 100%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    .rate-name {
      font-weight: 600;
      font-size: 18px;
      margin: 0;
      position: relative;
      margin-block: 3px;
    }
    .rate-price {
      font-weight: 400;
      font-size: 14px;
      margin: 0;
      line-height: 24px;

      .bold {
        font-weight: bolder;
      }
    }
  }

  .swiper-slide img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .append-buttons {
    text-align: center;
    margin-top: 20px;
  }

  .append-buttons button {
    display: inline-block;
    cursor: pointer;
    border: 1px solid #007aff;
    color: #007aff;
    text-decoration: none;
    padding: 4px 10px;
    border-radius: 4px;
    margin: 0 10px;
    font-size: 13px;
  }

  .rooms-bottom {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
    background-color: white;
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
    padding: 20px 15px;
  }
  .btns {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    padding: 8px 0;
    div {
      color: #2d2d4b;
      font-weight: 600;
      font-size: 16px;
      line-height: 123.9%;
      display: flex;
      align-items: center;
      cursor: pointer;

      &.disabled {
        opacity: 0.6;
      }
    }
  }
  .accordion-box {
    width: 100% !important;
    &,
    p,
    h6 {
      color: ${(props) => get(props, "design.colors.text", c.text)} !important;
    }

    p {
      margin: 0;
      font-weight: 500;
      width: 100%;
      line-height: 123.9%;
      align-items: center;
    }
    h6 {
      margin: 0;
      color: black;
      font-weight: bold;
    }
    .acordion-desc {
      width: 100%;
      p {
        margin: 0;
        font-weight: 500;
        font-size: 24px;
        line-height: 123.9%;
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 100%;
        .bold {
          font-weight: 700;
        }
      }
    }

    .MuiAccordionDetails-root {
      border: none !important;
    }
  }
  .MuiAccordionSummary-content {
    max-width: calc(100% - 31px);
  }

  @media (max-width: 960px) {
    border-radius: 0 0 16px 16px;

    .rates-container {
      border-left: 1px solid #e3e3e6;
      .arrow {
        display: flex;
      }

      .arrow-prev {
        border-block: 1px solid #e3e3e6;
        border-right: 1px solid #e3e3e6;
      }
      .arrow-next {
        border-block: 1px solid #e3e3e6;
        border-right: 1px solid #e3e3e6;
      }
      .swiper {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
      }
    }

    .acordion-desc {
      p {
        font-size: 20px;
      }
    }
  }

  @media (min-width: 961px) {
    .rates-container {
      position: relative;

      &:hover {
        .arrow {
          opacity: 1;
        }
      }

      .arrow {
        position: absolute;
        width: 30px;
        height: 30px;
        place-items: center;
        border-radius: 50%;
        top: 50%;
        margin-top: 0;
        opacity: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        transform: translateY(-50%);
        background: #d3d3d380;
        transition: 0.3 ease-in-out;
        z-index: 2;
        &::after {
          display: none;
        }
      }

      .arrow-prev {
        left: 5px;
        img {
          margin-left: -2px;
        }
      }

      .arrow-next {
        right: 5px;
        img {
          margin-right: -2px;
        }
      }

      .rate-slide {
        border-top: none !important;
        border-right: 1px solid #e3e3e6 !important;
        &::before {
          background: #e3e3e6 !important;
        }
      }
      .swiper {
        position: relative;
        &::after {
          content: "";
          width: 1px;
          height: 100%;
          position: absolute;
          right: 0;
          bottom: 1px;
          z-index: 2;
          background: #f5f4f9;
        }
      }
    }
  }

  @media (max-width: 576px) {
    .rate-name {
      font-size: 16px !important;
    }

    .rooms-bottom {
      padding: 10px;
    }
    .acordion-desc {
      p {
        font-size: 16px;
      }
    }
  }
`;

export default StyledRates;
